
import { AccountController } from "@/app/ui/controllers/AccountController";
import { Options, Vue, prop } from "vue-class-component";

class Props {
  flag = prop<string>({
    type: String,
    default: "",
  });
  regionName = prop<string>({
    type: String,
    default: "",
  });
  isStiDest = prop<boolean>({
    type: Boolean,
    default: false
  })
}

@Options({})
export default class PodIcon extends Vue.with(Props) {
  get isAccountForeign() {
    return AccountController.accountData?.accountIsForeign
  }

  get podIconSrc() {
    return this.isAccountForeign
      ? require('@/app/ui/assets/svg/sti-reverse-scan/icon-pod-en.svg')
      : require('@/app/ui/assets/svg/sti-reverse-scan/icon-pod.svg')
  }
}
